import { Stage } from '../types';

type StageStatusIcons = {
  created: string;
  running: string;
  fail: string;
  success: string;
};

type StagesStatuses = {
  [key in Stage['type']]: StageStatusIcons;
};

export const stagesStatuses: StagesStatuses = {
  compose: {
    created: '/static/i/gif/processing_icon5.gif',
    running: '/static/i/gif/processing_icon6.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon6.gif',
  },
  parse: {
    created: '/static/i/gif/processing_icon1.gif',
    running: '/static/i/gif/processing_icon2.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon2.gif',
  },
  thumbnail: {
    created: '/static/i/gif/processing_icon3.gif',
    running: '/static/i/gif/processing_icon4.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon4.gif',
  },
  markup: {
    created: '/static/i/gif/processing_icon3.gif',
    running: '/static/i/gif/processing_icon4.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon4.gif',
  },
  editableSlide: {
    created: '/static/i/gif/processing_icon3.gif',
    running: '/static/i/gif/processing_icon4.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon4.gif',
  },
  cloning: {
    created: '/static/i/gif/processing_icon3.gif',
    running: '/static/i/gif/processing_icon4.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon4.gif',
  },
  restyling: {
    created: '/static/i/gif/processing_icon3.gif',
    running: '/static/i/gif/processing_icon4.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon4.gif',
  },
  userCreated: {
    created: '/static/i/gif/processing_icon3.gif',
    running: '/static/i/gif/processing_icon4.gif',
    fail: '❌',
    success: '/static/i/gif/processing_icon4.gif',
  },
};
